export default {
    index: {
        listagem_unidades: 'Unit List',
        unidade_nao_encontrada: 'No Unit Found',
        criar_unidade: 'Create Unit',
        editar: 'Edit',
        nome: 'Name',
        apelido: 'Nickname'
    },
    form: {
        unidades: 'Units',
        empresa_principal: 'Core Company',
        informacoes: 'Informations',
        nome: 'Name',
        nome_descricao: 'Unit Name',
        mnemonico: 'Mnemonic',
        mnemonico_descricao: 'Unit Mnemonic',
        veus_id_descricao: 'Unit ID in Veus Saúde',
        vinculo: 'Bond',
        empresa_principal_descricao: 'Core Company',
        unidade_criada_sucesso: 'Unit successfully created!',
        unidade_atualizada_sucesso: 'Unit updated successfully!'
    }
}